import PlatformService from 'src/utils/Services/PlatformDBService';

import type { ApiCallRecord } from './api-call-history';

export const API_CALL_HISTORY_SYSTEM_CONFIG_KEY = 'debug_api_call_history_v1';

export type PersistedApiCallHistory = {
  version: 1;
  records: ApiCallRecord[];
};

export async function readPersistedApiCallHistory(): Promise<unknown> {
  const database = await PlatformService.getInstance();
  const entry = await database.getSystemConfig<unknown>(API_CALL_HISTORY_SYSTEM_CONFIG_KEY);
  return entry?.data ?? null;
}

export async function writePersistedApiCallHistory(
  records: readonly ApiCallRecord[]
): Promise<void> {
  const database = await PlatformService.getInstance();
  const payload: PersistedApiCallHistory = {
    version: 1,
    records: records.map((record) => ({ ...record })),
  };
  await database.updateOrCreateSystemConfig(API_CALL_HISTORY_SYSTEM_CONFIG_KEY, payload);
}

export async function deletePersistedApiCallHistory(): Promise<void> {
  const database = await PlatformService.getInstance();
  await database.deleteSystemConfig(API_CALL_HISTORY_SYSTEM_CONFIG_KEY);
}
